var exports = {
  "kL": "xcc377c0b--959765--container",
  "tM": "xcc377c0b--959765--with-icon",
  "Kk": "xcc377c0b--959765--icon",
};

module.exports = exports;
